/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skip_Reason_OtherInputs */

const vi_einvoice_skip_reason_other = /** @type {(inputs: Einvoice_Skip_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do khác`)
};

/**

* @param {Einvoice_Skip_Reason_OtherInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skip_reason_other = /** @type {((inputs?: Einvoice_Skip_Reason_OtherInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skip_Reason_OtherInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skip_reason_other(inputs)
});